<template>
  <v-card class="video-card" :class="mobileLandscape ? 'mx-8' : ''">
    <div class="video-iframe-container" id="iTechVideo">
      <iframe
        :key="iframeKey"
        id="video-iframe"
        :src="src"
        scrolling="no"
      ></iframe>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'VideoComponent',
  props: {
    src: {
      type: String,
      required: true,
    },
    authToken: {
      type: String,
    },
  },
  data() {
    return {
      isPortrait: false,
      mobileLandscape: false,
      iframeKey: 0,
    };
  },
  beforeUnmount() {
    this.wachterRemoveAwaitingAuthListener();
    window.removeEventListener('resize', this.checkOrientation);
  },
  methods: {
    checkOrientation() {
      const wasPortrait = this.isPortrait;
      const isMobile = /Mobi|Android/i.test(navigator.userAgent);
      this.isPortrait = window.innerHeight > window.innerWidth;
      this.mobileLandscape = isMobile && !this.isPortrait;
      // Remount iframe if orientation changed
      if (wasPortrait !== this.isPortrait) {
        this.iframeKey++;
      }
    },
    sendWachterAuth() {
      if (this.authToken) {
        document
          .getElementById('video-iframe')
          .contentWindow.postMessage({ jwt: this.authToken }, '*');
      }
    },
    wachterListenForAwaitingAuth() {
      window.addEventListener('message', this.wachterAwaitingAuth);
    },
    wachterRemoveAwaitingAuthListener() {
      window.removeEventListener('message', this.wachterAwaitingAuth);
    },
    wachterAwaitingAuth(event) {
      if (
        event?.data?.origin?.startsWith(this.src.toString()) &&
        event.data.event?.type === 'awaiting-auth'
      ) {
        this.sendWachterAuth();
      }
    },
  },
  mounted() {
    this.checkOrientation();
    this.wachterListenForAwaitingAuth();
    window.addEventListener('resize', this.checkOrientation);
  },
};
</script>

<style scoped>
.rotate-device-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  text-align: center;
  z-index: 1000;
}

.video-iframe-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%;
}

#video-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

#iTechVideo {
  height: 85vh;
}

#iTechWrapper {
  width: 80%;
}

/* Responsive Breakpoints */
@media only screen and (max-width: 1024px) and (orientation: portrait) {
  #iTechWrapper {
    width: 100%;
  }
}

@media (min-width: 320px) and (orientation: portrait) {
  #iTechVideo {
    height: 80vh;
  }
}

@media (min-width: 375px) and (orientation: portrait) {
  #iTechVideo {
    height: 75vh;
  }
}

@media (min-width: 411px) and (orientation: portrait) {
  #iTechVideo {
    height: 75vh;
  }
}

@media (min-width: 625px) and (max-width: 850px) {
  #iTechVideo {
    height: 85vh;
  }
}

/* @media (min-width: 745px) and (max-width: 850px) {
  #iTechVideo {
    height: 85vh;
  }
} */

@media (min-width: 850px) and (max-width: 960px) {
  #iTechVideo {
    height: 95vh;
  }
}

/* iPhone Landscape */
@media (min-width: 650px) and (max-width: 940px) and (orientation: landscape) {
  #iTechVideo {
    height: 160vh;
  }
}

@media (min-width: 1900px) {
  #iTechVideo {
    height: 85vh;
  }
}
</style>